import { ICoords } from "../types";

export interface IHandlers {
	onMove: (e: any, shift: ICoords, pressCoords: ICoords) => void;
	onUp: (e: any) => void;
}

class GlobalDrag {
	private _start: any;
	private _handler: any;
	private _context: any;
	private _isMove: boolean;

	start(e, handler: IHandlers, context: any) {
		this._handler = handler;
		this._context = context;

		this._start = {
			x: e.clientX,
			y: e.clientY,
		};

		document.addEventListener("mousemove", this._moveHandler);
		document.addEventListener("mouseup", this._upHandler);
		document.body.classList.add("dhx_noselect");
	}
	private _moveHandler = (e: any) => {
		// if cursor is moved more than 5px
		if (Math.abs(e.clientX - this._start.x) > 5 || Math.abs(e.clientY - this._start.y) > 5) {
			this._isMove = true;

			const shift = {
				x: e.clientX - this._start.x,
				y: e.clientY - this._start.y,
			};
			this._handler.onMove(e, shift, this._context);

			this._start.x += shift.x;
			this._start.y += shift.y;
		}
	};
	private _upHandler = e => {
		document.removeEventListener("mousemove", this._moveHandler);
		document.removeEventListener("mouseup", this._upHandler);
		document.body.classList.remove("dhx_noselect");

		if (this._isMove) {
			this._handler.onUp(e);
		} else if (typeof this._handler.connectOnUp === "function") {
			this._handler.connectOnUp(e);
		}
		this._isMove = this._handler = this._start = null;
	};
}

export const drag = new GlobalDrag();
